(function ($) {
    $('.masonry-grid .grid-item .grid-item-content').on('click', function (e) {
        var targetURL = $(this).attr('target-url');
        if (targetURL) {
            window.location.href = targetURL;
        }
    });
})(jQuery);
